// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__9_UdN","actionsCol":"EnrolledClinics_actionsCol__2wuny"};